<p-dialog [style]="{width: '1000px', height:'1000px'}" header="BH Provider Lab Review Attestation" [(visible)]="display" [modal]="true" (onHide)="cancelDialog()">
    <app-member-labs-attestation [memberCIN]="memberCIN" (onsavesuccess)="onsavesuccess()" (onsavefailed)="onsavefailed()"  (onchange)="onchange()" #memberlabattestation></app-member-labs-attestation>
    <p-footer>
        <div *ngIf="showAlert == 1"> 
            <app-alert-success [subjectMessage]="'Success'" [uniqueID]="'savesuccess'" [contentMessage]="'Submitted Successfully.'"></app-alert-success>
        </div>    
        <div *ngIf="showAlert == 2">
            <app-alert-danger [subjectMessage]="'Error'" [uniqueID]="'savefailed'" [contentMessage]="'Failed to save. Try again !!!'"></app-alert-danger>
        </div>           
        <div *ngIf="showAlert == 3">
            <app-alert-danger [subjectMessage]="'Validation Error'" [uniqueID]="'saveerror'" [contentMessage]="validationErrorMessage"></app-alert-danger>
        </div>                   
        <div>
            <button type="button" class="btn btn-secondary btn-cancel" (click)="cancelDialog()">Cancel</button>
            <button type="button" class="btn btn-primary btn-create" (click)="onSubmit()" [disabled]="!canAttest">Submit</button>      
        </div>
    </p-footer>
</p-dialog>
